import React from 'react';
import styled from '@emotion/styled';
import {
	DateSelect,
	IDateSelectItemOrDate,
	IDropdownItem,
	Select,
} from '../../../ui';
import { TimeSelect } from '../../shared/components/time-select/TimeSelect';
import {
	createTimeOption,
	MaybeTimeOption,
} from '../../shared/components/time-select/TimeOption';

const options = ['foo', 'bar', 'baz'];

const optionsWithHint = [
	{
		type: 'item' as const,
		key: 'foo',
		value: 'foo',
		hint: 'hint foo',
	},
	{
		type: 'item' as const,
		key: 'bar',
		value: 'bar',
		hint: 'hint bar',
	},
	{
		type: 'item' as const,
		key: 'baz',
		value: 'baz',
		hint: 'hint baz',
	},
];

const timeOptions = ['10:00', '11:00', '12:00', '13:00'].map(createTimeOption);

function onChangeSelect(item: IDropdownItem | null) {
	// eslint-disable-next-line no-console
	console.log('Selected changed', { current: item });
}

function onChangeDay(item: IDateSelectItemOrDate | null) {
	// eslint-disable-next-line no-console
	console.log('Date changed', { current: item });
}

function onChangeTime(item: MaybeTimeOption) {
	// eslint-disable-next-line no-console
	console.log('Time changed', { current: item });
}

const SelectsWrap = styled.div`
	max-width: 600px;
`;

const Row = styled.div`
	margin-bottom: 30px;

	&:last-child {
		margin-bottom: 0;
	}

	> div {
		margin-top: 10px;
	}
`;

export const Selects = () => {
	const today = new Date();

	const yesterday = new Date();
	yesterday.setDate(today.getDate() - 1);

	const tomorrow = new Date();
	tomorrow.setDate(today.getDate() + 1);

	const days = [yesterday, today, tomorrow];

	const daysWithHint = [
		{
			value: yesterday,
			hint: 'Yesterday',
		},
		{
			value: today,
			hint: 'Today',
		},
		{
			value: tomorrow,
			hint: 'Tomorrow',
		},
	];

	return (
		<SelectsWrap>
			<h2 id="select">Select</h2>

			<Row>
				Default select:
				<Select
					items={options}
					onChange={onChangeSelect}
					placeholder="Please select an option"
				/>
			</Row>

			<Row>
				Select with hints:
				<Select
					items={optionsWithHint}
					onChange={onChangeSelect}
					placeholder="Please select an option"
				/>
			</Row>

			<Row>
				Select with initial selected item:
				<Select
					items={options}
					initialSelectedItem={options[0]}
					onChange={onChangeSelect}
					placeholder="Please select an option"
				/>
			</Row>

			<Row>
				Date Select:
				<DateSelect
					items={days}
					initialSelectedItem={days[1]}
					onChange={onChangeDay}
					placeholder="Please select an option"
				/>
			</Row>

			<Row>
				Date Select with hint:
				<DateSelect
					items={daysWithHint}
					initialSelectedItem={daysWithHint[1]}
					onChange={onChangeDay}
					placeholder="Please select an option"
				/>
			</Row>

			<Row>
				Time Select:
				<TimeSelect
					items={timeOptions}
					onChange={onChangeTime}
					placeholder="Select time"
				/>
			</Row>
		</SelectsWrap>
	);
};
